<template>
  <div class="ranking" v-infinite-scroll="getData" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
    <CustomizeHeader :home="false" :goBack="true" title="熱門榜"></CustomizeHeader>
      <div class="d-flex">
        <v-select
          class="pa-2"
          :items="product_types"
          v-model="selected_type"
          item-color="pink"
          hide-details
          solo
          return-object
        ></v-select>
        <v-select
          class="pa-2"
          :items="ranking_types"
          v-model="selected_ranking_type"
          item-color="pink"
          hide-details
          solo
          return-object
          :disabled="checkDisable()"
        ></v-select>
      </div>
    </v-tabs>
    <v-row v-if="selected_type.value != 'member'" no-gutters>
      <v-col 
        style="padding: 6px"
        v-for="(item, i) in items"
        :key="i"
        :cols="['story', 'photo'].includes(item.latest_product.product_type) ? 4 : 6"
        :sm="['story', 'photo'].includes(item.latest_product.product_type) ? 3 : 4" 
        :md="['story', 'photo'].includes(item.latest_product.product_type) ? 2 : 3" 
        :lg="['story', 'photo'].includes(item.latest_product.product_type) ? 1 : 2" 
        :xl="['story', 'photo'].includes(item.latest_product.product_type) ? 1 : 2"
      >
        <template v-if="['story', 'photo'].includes(item.latest_product.product_type)">
          <v-card height="100%" class="story-item" flat @click="$root.$emit('story', item, item.latest_product, item.latest_product.product_type)">
            <span class="free" v-if="item.latest_product.price === 0">Free</span>
            <span class="unlocked" v-else-if="purchaseID.includes(item.latest_product.id)">已解鎖</span>
            <v-img
              :src="$func.productImagePreview(item.latest_product)"
              gradient="to bottom, rgba(0,0,0,.0), rgba(0,0,0,.4)"
              height="100%"
              aspect-ratio="0.75"
            >
              <v-avatar size="35" :title="item.nickname" @click.stop="$router.push(`/seller/${item.id}`)">
                <v-img :src="$HOST_URL + item.usericon"/>
              </v-avatar>
              <div class="description" :title="item.latest_product.title">{{ item.latest_product.title }}</div>
            </v-img>
          </v-card>
        </template>

        <template v-else>
          <v-card 
            class="product-item" 
            :to="`/product/${item.latest_product.id}`"
            flat
            @mouseover="item.latest_product.product_type == 'video' ? $func.startPlayVideo($refs, i, $HOST_URL + item.latest_product.video_info[0].uuid_path) : ''"
            @mouseleave="item.latest_product.product_type == 'video' ? $func.stopPlayVideo($refs, i) : ''"
          >
            <span class="free" v-if="item.latest_product.price === 0">Free</span>
            <span class="unlocked" v-if="purchaseID.includes(item.latest_product.id)">已解鎖</span>
            <div class="soldOut" v-if="item.latest_product.sold > 0 && item.latest_product.product_type == 'clothes'">售罄</div>
            <div :class="{sold: item.latest_product.sold > 0 && item.latest_product.product_type == 'clothes'}" style="width: 100%">
              <template v-if="item.latest_product.product_type == 'video'">
                <video-player 
                  v-once
                  :ref="`video${i}`"
                  v-touch-event="() => $router.push(`/product/${item.latest_product.id}`)"
                  :playsinline="true" 
                  @canplay="$func.onPlayerCanplay($event, i)"
                  :options="$func.videoOption({
                    src: null,
                    autoplay: false,
                    muted: true,
                    loop: true,
                    controls: false,
                    poster: $HOST_URL + item.latest_product.video_info[0].preview_path
                  })"></video-player>
              </template>
              <template v-else>
                <v-img :src="$func.productImagePreview(item.latest_product)" aspect-ratio="1.75" />
              </template>
              <div class="information">
                <v-avatar size="35" class="mr-2" :title="item.nickname" @click.prevent="$router.push(`/seller/${item.id}`)">
                  <v-img :src="$HOST_URL + item.usericon"/>
                </v-avatar>
                <v-col class="pa-0 rightInfo">
                  <div class="product-title text-ellipsis" :title="item.latest_product.title">{{ item.latest_product.title }}</div>
                  <div class="d-flex align-cente review">
                    <template v-if="!['clothes'].includes(item.latest_product.product_type)">
                      <v-icon>fa-thumbs-up</v-icon>
                      <span>{{ mul(item.latest_product.praise_rate, 100) }}%</span>
                    </template>
                    <template v-if="['video', 'photo'].includes(item.latest_product.product_type)">
                      <v-icon>fa-unlock</v-icon>
                      <span>{{ item.latest_product.unlocks }}</span>
                    </template>
                    <template v-if="['clothes'].includes(item.latest_product.product_type)">
                      <v-icon>fa-eye</v-icon>
                      <span>{{ item.latest_product.views }}</span>
                    </template>
                  </div>
                </v-col>
              </div>
            </div>
          </v-card>
        </template>
      </v-col>
    </v-row>

    <v-list v-else dark class="transparent">
      <v-list-item 
        v-for="(item, i) in items" 
        :style="i == 0 ? 'background-color: #ebba46' : i == 1 ? 'background-color: #919191' : i == 2 ? 'background-color: #d17e54' : ''"
      >
        <div class="mr-6 title" :style="i == 0 ? 'color: #966e17' : i == 1 ? 'color: #494949' : i == 2 ? 'color: #7d4830' : ''">{{ i + 1 }}</div>
        <v-list-item-avatar class="mr-4">
          <v-img :src="$HOST_URL + item.usericon"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ item.nickname }}</v-list-item-title>
        </v-list-item-content>
        <!-- <v-menu bottom content-class="profile-card">
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex" v-bind="attrs" v-on="on">
              <v-list-item-avatar class="mr-4">
                <v-img :src="$HOST_URL + item.usericon"></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.nickname }}</v-list-item-title>
              </v-list-item-content>
            </div>
          </template>
          <v-card class="pa-4">
            <v-list-item class="pa-0 mb-4">
              <v-list-item-avatar size="50" tile>
                <v-avatar tile>
                  <v-img :src="$HOST_URL + item.usericon"/>
                </v-avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="font-weight-regular mb-1">
                  {{ item.nickname }}
                </v-list-item-title>
                <v-rating
                  x-small
                  dense
                  readonly
                  half-increments
                  :value="5"
                  background-color="yellow darken-2"
                  color="yellow darken-2"
                ></v-rating>
              </v-list-item-content>
            </v-list-item>
            <v-btn dark v-if="true" block class="mt-4 pink">追蹤用戶</v-btn>
            <v-btn dark v-else block class="mt-4 pink">取消追蹤</v-btn>
            <v-btn v-if="true" block outlined class="mt-4 red--text">封鎖</v-btn>
            <v-btn v-else block outlined class="mt-4 red--text">解除封鎖</v-btn>
          </v-card>
        </v-menu> -->
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CustomizeHeader from '@/components/CustomizeHeader'
export default {
  components: { CustomizeHeader },
  data() {
    return {
      busy: false,
      tab: 0,
      page: 1,
      selected_type: {text: '綜合', value: 'all'},
      selected_ranking_type: {text: '月排名', value: 'month'},
      items: []
    }
  },
  computed: {
    ...mapGetters('user', ['purchaseID']),
    product_types() {
      return [
        {text: '綜合', value: 'all'},
        ...this.$product_types,
        {text: '會員', value: 'member'},
      ]
    },
    ranking_types() {
      return [
        {text: '月榜', value: 'month'},
        {text: '日榜', value: 'day'}
      ]
    }
  },
  watch: {
    selected_type() {
      this.page = 1
      this.items = []
      this.busy = false
    },
    selected_ranking_type() {
      this.page = 1
      this.items = []
      this.busy = false
    }
  },
  methods: {
    async getData() {
      this.busy = true
      let last_page = null
      if(this.selected_type.value != 'member') {
        last_page = await this.getProducts()
      }
      else {
        last_page = await this.getMemebers()
      }
      if(this.page != last_page) {
        this.page += 1  
        this.busy = false
      }
    },
    getProducts() {
      return this.axios(`/product/rank/${this.selected_type.value}?type=${this.selected_ranking_type.value}&page=${this.page}&size=50`).then(response => {
        this.items = this.items.concat(response.data.data.filter(item => item[`latest_${this.selected_type.value}_product`]).map(item => {
          item.latest_product = item[`latest_${this.selected_type.value}_product`]
          return item
        }))
        return response.data.last_page
      })
    },
    getMemebers() {
      return this.axios(`/member/rank?page=${this.page}&size=50`).then(response => {
        this.items = this.items.concat(response.data.data)
        return response.data.last_page
      })
    },
    checkDisable() {
      if(this.selected_type.value == 'member') {
        this.selected_ranking_type = this.ranking_types.find(type => type.value == 'month')
        return true
      }
      else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.type-menu {
  min-height: 304px;
  left: 0 !important;
  .v-list {
    background-color: $grey-3;
    text-align: center;
  }
}
.ranking {
  .col-lg-1 {
    @media (min-width: 1904px) {
      flex: unset;
      max-width: 11% !important;
    }
    @media (min-width: 1264px) {
      flex: unset;
      max-width: 11% !important;
    }
  }
  .col-4 {
    @media (max-width: 599px) {
      flex: unset;
      max-width: 36%;
    }
  }
  .v-list-item {
    margin: 8px 0;
    padding: 8px 16px;
    background-color: $grey-2;
  }
}
</style>